// Apolo IDE — API base URL resolver.
//
// Packaged Electron: build may inject VITE_APOLO_API at build time.
// Dev (`npm run dev`): defaults to the DEPLOYED Worker so OpenRouter/agent-turn
// works after `cd apolo-api && npm run deploy` without also running wrangler dev.
// Local Worker: create apolo/.env.development.local with:
//   VITE_APOLO_API=http://localhost:8787

const PROD_URL = 'https://apolo-ide-api.pedromleal.workers.dev';
const LOCAL_URL = 'http://localhost:8787';

export function getApiBase() {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const injected = import.meta.env.VITE_APOLO_API;
    if (injected && typeof injected === 'string') return injected.replace(/\/$/, '');
    if (import.meta.env.MODE !== 'production') return PROD_URL;
  }
  return PROD_URL;
}

export const LOCAL_API_URL = LOCAL_URL;

/** Join base + path while normalizing slashes. */
export function apiUrl(path) {
  const base = getApiBase();
  if (!path.startsWith('/')) return `${base}/${path}`;
  return `${base}${path}`;
}
